import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import AccessibleModal, {
    AccessibleModalCloseButton,
} from '../AccessibleModal';

import { gettext } from '../../utils/text';
import GallerySlider from './GallerySlider';
import sort from './utils';

const StagingGallery = ({ data }) => {
    const [initialSlide, setSlide] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const translatedText = gettext('Gallery');

    const images = data.images.sort(sort);

    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            <h3 className="mb-5">{translatedText}</h3>
            <div className="gallery-grid">
                {images.map((image, idx) => (
                    <div
                        className="gallery-grid__item"
                        key={`order-${image.file.pk}`}
                    >
                        <Dialog.Trigger asChild>
                            <button
                                type="button"
                                className="gallery-grid__button"
                                onClick={() => {
                                    setSlide(idx);
                                    setIsOpen(true);
                                }}
                                aria-label={`${translatedText}, ${gettext(
                                    'image',
                                )} ${idx + 1} of ${images.length}`}
                            >
                                <img
                                    alt=""
                                    src={
                                        image.file.thumbnail || image.file.file
                                    }
                                />
                            </button>
                        </Dialog.Trigger>
                    </div>
                ))}
            </div>
            <AccessibleModal
                contentClassName="gallery-modal"
                contentStyle={{
                    width: '100vw',
                    maxWidth: '100vw',
                    height: '100vh',
                }}
                initialFocusSelector=".splide__arrow--next"
            >
                <Dialog.Title asChild>
                    <VisuallyHidden>{translatedText}</VisuallyHidden>
                </Dialog.Title>
                <Dialog.Description asChild>
                    <VisuallyHidden>
                        {gettext(
                            'Image gallery. Use the next and previous buttons to browse images.',
                        )}
                    </VisuallyHidden>
                </Dialog.Description>
                <AccessibleModalCloseButton
                    className="btn-close bg-white p-3 z-3 position-absolute top-0 end-0 m-3"
                    aria-label={gettext('Close')}
                />
                <GallerySlider images={images} initialSlide={initialSlide} />
            </AccessibleModal>
        </Dialog.Root>
    );
};

StagingGallery.propTypes = {
    data: PropTypes.shape({
        images: PropTypes.arrayOf(
            PropTypes.shape({
                file: PropTypes.shape({
                    pk: PropTypes.number,
                    file: PropTypes.string,
                    thumbnail: PropTypes.string,
                }),
            }),
        ).isRequired,
    }).isRequired,
};

export default StagingGallery;
